import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { StoreContext } from "shared/context/store-context";

import { useShiftBackend } from "shared/hooks/backend/shift-hook";
import { useFreeSms } from "shared/hooks/backend/free-sms-hook";

import Tabs from "components/shared/Tabs";
import { createTransferAnalyzerHandlers } from "./transferAnalyzerHandlers";
import { buildTransferAnalyzerTabs } from "./tabs/TransferAnalyzerTabs";
import TransferAnalyzerMap from "./TransferAnalyzerMap";

const TransferAnalyzer = ({ school, transfer, transfertime, services, displayName, servicesOptions, onClose }) => {
  const { t } = useTranslation();
  const { users, UpdatePersonelService, InsertPersonelService, DeletePersonelService, UpdateTransfer } =
    useContext(StoreContext);

  const type = "100";

  const {
    updateUsersInTheService,
    updateUsersDetailsInTheService,
    addService,
    deleteService,
    updateVehicleRoutesInTheTransfer,
  } = useShiftBackend();

  const [usersInTheTransfer, setUsersInTheTransfer] = useState([]);

  useEffect(() => {
    if (services.length) {
      const allUsersIds = services.reduce((acc, service) => {
        return [...acc, ...service.users.map((user) => user.id)];
      }, []);
      setUsersInTheTransfer(users.filter((user) => allUsersIds.includes(user.id)));
    }
  }, [services, transfer, users]);

  const { sendFreeSms } = useFreeSms();

  const [tabValue, setTabValue] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handlers = React.useMemo(
    () =>
      createTransferAnalyzerHandlers({
        t,
        users,
        services,
        usersInTheTransfer,
        setUsersInTheTransfer,
        school,
        transfer,
        type,
        updateUsersInTheService,
        updateUsersDetailsInTheService,
        addService,
        deleteService,
        updateVehicleRoutesInTheTransfer,
        sendFreeSms,
        UpdatePersonelService,
        InsertPersonelService,
        DeletePersonelService,
        UpdateTransfer,
      }),
    [
      t,
      users,
      services,
      usersInTheTransfer,
      school,
      transfer,
      type,
      updateUsersInTheService,
      updateUsersDetailsInTheService,
      addService,
      deleteService,
      updateVehicleRoutesInTheTransfer,
      sendFreeSms,
      UpdatePersonelService,
      InsertPersonelService,
      DeletePersonelService,
      UpdateTransfer,
    ]
  );

  const transferAnalyzerTabs = React.useMemo(
    () =>
      buildTransferAnalyzerTabs({
        t,
        transfer,
        onClose,
        usersInTheTransfer,
        services,
        servicesOptions,
        school,
        displayName,
        transfertime,
        type,
        handlers,
      }),
    [
      t,
      transfer,
      onClose,
      usersInTheTransfer,
      services,
      servicesOptions,
      school,
      displayName,
      transfertime,
      type,
      handlers,
    ]
  );

  return (
    <div>
      <Tabs tabs={transferAnalyzerTabs} tabValue={tabValue} onTabChange={handleTabChange} isVertical={false} />
      <TransferAnalyzerMap
        usersInTheTransfer={usersInTheTransfer}
        school={school}
        type={type}
        transfertime={transfertime}
      />
    </div>
  );
};

export default TransferAnalyzer;
